import { QrCode, CreditCard, Landmark, FileText } from "lucide-react";

const METHODS = [
    {
        icon: QrCode,
        code: "PIX",
        title: "PIX Instantâneo",
        desc: "Transferência rápida na liberação do serviço.",
        testid: "payment-pix",
    },
    {
        icon: CreditCard,
        code: "DÉB",
        title: "Cartão de Débito",
        desc: "Pagamento com cartão de débito no atendimento.",
        testid: "payment-debito",
    },
    {
        icon: Landmark,
        code: "CRÉD",
        title: "Cartão de Crédito",
        desc: "Principais bandeiras de crédito aceitas.",
        testid: "payment-credito",
    },
    {
        icon: FileText,
        code: "BOL",
        title: "Boleto Bancário",
        desc: "Exclusivo para empresas previamente cadastradas.",
        testid: "payment-boleto",
    },
];

export const Payment = () => (
    <section
        id="pagamento"
        data-testid="payment-section"
        className="py-24 bg-white border-b border-neutral-200"
    >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="text-center max-w-xl mx-auto mb-16">
                <span className="text-xs font-bold uppercase tracking-widest text-[#ff6200]">
                    Facilidade
                </span>
                <h2 className="display-type text-3xl sm:text-4xl text-neutral-900 mt-1">
                    FORMAS DE PAGAMENTO
                </h2>
                <p className="text-neutral-600 text-xs mt-2">
                    Opções flexíveis e seguras para motoristas particulares e empresas.
                </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {METHODS.map((m) => (
                    <div
                        key={m.code}
                        data-testid={m.testid}
                        className="p-6 rounded-xl bg-[#f8f9fa] border border-neutral-200 text-center"
                    >
                        <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#ff6200]/10 text-[#ff6200] flex items-center justify-center font-bold">
                            <m.icon className="w-6 h-6" aria-label={m.code} />
                        </div>
                        <h4 className="font-bold text-neutral-900 text-sm">{m.title}</h4>
                        <p className="text-xs text-neutral-500 mt-1">{m.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
